function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Order_history"
}, /*#__PURE__*/React.createElement("path", {
  d: "m251.2305 448h-180.457a150.4432 150.4432 0 0 0 32.2656-93.5391v-290.4609h278.3945v153.1719a8 8 0 0 0 16 0v-161.1719a7.9979 7.9979 0 0 0 -8-8h-294.3945a7.9979 7.9979 0 0 0 -8 8v298.4609a134.7126 134.7126 0 0 1 -39.711 95.8829 7.9993 7.9993 0 0 0 5.6563 13.6562h198.2461a8 8 0 0 0 0-16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m333.9961 148.7656h-183.52a8 8 0 0 0 0 16h183.52a8 8 0 0 0 0-16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m341.9961 210.9688a7.9979 7.9979 0 0 0 -8-8h-183.52a8 8 0 1 0 0 16h183.52a7.9979 7.9979 0 0 0 8-8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m262.2305 265.1719a7.9979 7.9979 0 0 0 -8-8h-103.7539a8 8 0 0 0 0 16h103.7539a7.9979 7.9979 0 0 0 8-8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m150.4766 311.375a8 8 0 1 0 0 16h65.2539a8 8 0 0 0 0-16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m436.7266 287.4609a103.32 103.32 0 0 0 -174.9361 55.4121l-6.3569-6.3574a7.9991 7.9991 0 0 0 -11.3125 11.3125l18.4089 18.4082a8.026 8.026 0 0 0 11.3232 0l18.4126-18.4082a7.9991 7.9991 0 0 0 -11.3125-11.3125l-1.8169 1.8164a87.3378 87.3378 0 1 1 22.6568 84.0664 7.9991 7.9991 0 0 0 -11.3125 11.3125 103.413 103.413 0 0 0 146.2461-146.25z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m363.6055 291.32a7.9979 7.9979 0 0 0 -8 8v61.2656a8.115 8.115 0 0 0 2.3506 5.6641l28.9931 28.9922a7.9991 7.9991 0 0 0 11.3125-11.3119l-26.6562-26.6563v-57.9537a7.9979 7.9979 0 0 0 -8-8z"
}));

var SvgHistory = function SvgHistory(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHistory, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/history.74630d0f.svg";
export { ForwardRef as ReactComponent };